import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCategory = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	color: "#0f1826",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M1.50024 2.39126V6.10899C1.50019 6.58162 1.68784 7.03493 2.02193 7.36923L8.89115 14.2391C9.05829 14.4061 9.28494 14.5 9.52127 14.5C9.7576 14.5 9.98426 14.4061 10.1514 14.2391L14.2387 10.1511C14.4058 9.98401 14.4996 9.75736 14.4996 9.52103C14.4996 9.2847 14.4058 9.05804 14.2387 8.89091L7.36948 2.02168C7.03517 1.68759 6.58187 1.49994 6.10924 1.5H2.3915C2.15513 1.5 1.92843 1.5939 1.76129 1.76104C1.59414 1.92819 1.50024 2.15488 1.50024 2.39126Z",
		stroke: "currentColor",
		strokeLinecap: "round",
		strokeLinejoin: "round"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M3.72839 4.6194C3.72839 4.85578 3.82229 5.08248 3.98943 5.24962C4.15658 5.41676 4.38327 5.51066 4.61965 5.51066C4.85602 5.51066 5.08272 5.41676 5.24986 5.24962C5.41701 5.08248 5.51091 4.85578 5.51091 4.6194C5.51091 4.38303 5.41701 4.15633 5.24986 3.98919C5.08272 3.82205 4.85602 3.72815 4.61965 3.72815C4.38327 3.72815 4.15658 3.82205 3.98943 3.98919C3.82229 4.15633 3.72839 4.38303 3.72839 4.6194Z",
		stroke: "currentColor",
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})]
});
export default SvgCategory;
